import { toUpper } from 'ramda';

import { MHTopic, MHTopicId } from '@data/mh_topics';

import { IScheduledAppointment } from '@folx-types/scheduledAppointments';

import { ServiceType } from '@components/NewAppointmentBooking';

export const hasMHMAppointments = (appointmentData) =>
	appointmentData &&
	appointmentData?.filter(
		(appointment: IScheduledAppointment) => appointment.serviceInfo?.type === toUpper(MHTopicId.mhm)
	).length > 0;

type serviceTypeStyle = 'abbreviated' | 'underscored' | 'hyphenated';
const serviceTypes: Record<MHTopicId, Record<serviceTypeStyle, string>> = {
	vc: {
		abbreviated: MHTopicId.vc,
		underscored: 'virtual_care',
		hyphenated: 'virtual-care',
	},
	mhm: {
		abbreviated: MHTopicId.mhm,
		underscored: 'mh_medication',
		hyphenated: 'mh-medication',
	},
	mht: {
		abbreviated: MHTopicId.mht,
		underscored: 'mh_therapy',
		hyphenated: 'mh-therapy',
	},
	mhl: {
		abbreviated: MHTopicId.mhl,
		underscored: 'mh_letter',
		hyphenated: 'mh-letter',
	},
};

export const getServiceType = (
	topicId?: MHTopic,
	options?: { uppercase?: boolean; vcFlow?: boolean; style?: serviceTypeStyle }
) => {
	let serviceType: ServiceType;
	const serviceTypeStyle: serviceTypeStyle = options?.style ?? 'abbreviated';

	switch (topicId) {
		case MHTopic.TALK_THERAPY:
			serviceType = MHTopicId.mht;
			break;

		case MHTopic.MEDICATION_MANAGEMENT:
			serviceType = options?.vcFlow ? MHTopicId.vc : MHTopicId.mhm;
			break;

		case MHTopic.THERAPY_AND_MEDICATION:
			serviceType = options?.vcFlow ? MHTopicId.vc : MHTopicId.mhm;
			break;

		case MHTopic.ADHD:
			serviceType = MHTopicId.vc;
			break;

		case MHTopic.MENTAL_HEALTH_LETTER:
			serviceType = MHTopicId.mhl;
			break;

		default:
			serviceType = MHTopicId.mht;
			break;
	}

	const serviceTypeValue = serviceTypes[serviceType][serviceTypeStyle];
	return options?.uppercase ? toUpper(serviceTypeValue) : serviceTypeValue;
};
